import React from 'react';
import InfoSection from '../InfoSection';
import MediaGallery from '../MediaGallery';
import styled from 'styled-components';

const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  width: 100%;
  max-width: 1200px;
  margin: 60px auto 0;
  padding: 0 20px 100px;
`;

const ServicesHeader = styled.h2`
  font-size: 2.5rem;
  font-weight: 600;
  color: #010606;
  margin: 80px 0 40px;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 2px;
`;

const ServicesSubheader = styled.p`
  font-size: 1.2rem;
  color: #01bf71;
  margin-bottom: 40px;
  text-align: center;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
`;

const ServiceCard = styled.div`
  background: white;
  border-radius: 15px;
  padding: 30px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }
`;

const ServiceTitle = styled.h3`
  font-size: 1.5rem;
  color: #010606;
  margin-bottom: 15px;
  font-weight: 600;
`;

const ServiceDescription = styled.p`
  font-size: 1rem;
  color: #666;
  line-height: 1.6;
`;

const ServicesSection = () => {
  const services = [
    {
      title: "Award Winning Clickfunnels",
      description: "We build high-converting, professionally optimized ClickFunnels tailored to your product or service. Our award-winning funnel architects design every page with strategic copy, proven conversion principles, and seamless user flows, helping you turn traffic into sales at scale."
    },
    {
      title: "Clipping Teams",
      description: "Our in-house content teams produce and distribute over 15,000+ short-form videos monthly across 240+ accounts on TikTok, Instagram, and X from your raw, unedited, long form content. We use these teams to grow brands by leveraging performance data to guide expert editing, viral formatting, and optimized posting strategies for maximum reach."
    },
    {
      title: "AI Automailer",
      description: "Our AI-driven email outreach system delivers over 15,000 double-verified emails monthly to targeted leads with guaranteed inbox placement: completely on autopilot. Using LinkedIn-verified contact data and proprietary scraping tools, we ensure 100% deliverability, no spam folders, no junk, just targeted outreach that drives responses and sales. This tool fully automates your cold email outreach, without having to pay a BDR’s base + commission."
    }
  ];

  return (
    <>
      <ServicesHeader>More Services</ServicesHeader>
      <ServicesSubheader>Discover our additional specialized services</ServicesSubheader>
      <ServicesGrid>
        {services.map((service, index) => (
          <ServiceCard key={index}>
            <ServiceTitle>{service.title}</ServiceTitle>
            <ServiceDescription>{service.description}</ServiceDescription>
          </ServiceCard>
        ))}
      </ServicesGrid>
    </>
  );
};

const CombinedContent = () => {
  return (
    <>
      <MediaGallery />
      <ServicesSection />
    </>
  );
};

const OurWorkSection = () => {
  return (
    <InfoSection
      id="work"
      lightBg={true}
      lightText={false}
      darkText={true}
      topLine="Our Work"
      headLine="Check Out Our Latest Projects"
      description="Browse through our portfolio of successful campaigns and creative content that we've produced for our clients."
      imgStart={false}
      hideImage={true}
      showMediaGallery={true}
      additionalComponent={CombinedContent}
    />
  );
};

export default OurWorkSection; 